import Link from "next/link"
import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import { useEffect, useRef, useState } from "react"
import { getAccessToken } from "lib/Cookies"
import LoginAlert from "components/ModalLogin/LoginAlert"
import { Modal } from "components/ui"
import Tippy from "@tippyjs/react"
import "tippy.js/dist/tippy.css"

export default function Component(props) {
  let display_type = true
  const router = useRouter()
  const { toggleModalLogin, signKey, userInfo } = useStore()
  const { status, id, type, is_protected } = props
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      // toggleModalLogin()
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    toggleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (isMonter.current) {
      router.push(`/video?id=${id}&type=${type}`)
    }
  }, [signKey])

  useEffect(() => {
    if (isMonter.current) {
      router.push(`/video?id=${id}&type=${type}`)
    }
  }, [userInfo])

  if (status !== "live") {
    return (
      <div className="cursor-pointer">
        <CardLiveHorizontal {...props} />
      </div>
    )
  } else {
    return (
      <>
        <Link href={`/video?id=${id}&type=${type}`}>
          <div onClick={onClick} className="cursor-pointer">
            <CardLiveHorizontal {...props} />
          </div>
        </Link>
        <Modal
          isOpen={isModal}
          onCancel={() => {
            setIsModal(false)
          }}
          showIcon={false}
        >
          <LoginAlert
            onCancel={() => {
              setIsModal(false)
            }}
            onNext={onNext}
          />
        </Modal>
      </>
    )
  }
}

function CardLiveHorizontal({
  attribute,
  status,
  name,
  start_time,
  league_name,
  thumbnail,
  logo_league,
  categories_name,
  category_name,
  league_logo
}) {
  const setModalLive = useStore().setModalLive
  const {
    away_logo,
    away_name,
    away_thumbnail,
    away_score,
    home_logo,
    home_name,
    home_thumbnail,
    home_score,
    livescore_type,
    number_of_matches,
    number_of_teams
  } = attribute || {}

  const containerRef = useRef(null)

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  function nextPath() {
    if (status !== "live") {
      setModalLive({
        show: true,
        isVod: false,
        info: {
          name,
          home_name,
          away_name,
          start_time
        }
      })
    }
  }

  return (
    <div onClick={nextPath}>
      <div className="relative wapper__play" ref={containerRef}>
        <div className="relative flex items-center rounded-xl bg-[#232323] p-4 max-md:p-3 gap-3 max-w-[100vw] w-full border border-transparent hover:border-white">
          {livescore_type === 0 ? (
            <div className="flex flex-col gap-3 max-md:gap-2 w-full">
              <div className="flex justify-between items-center rounded-lg bg-[#1a1a1a] px-3 max-sm:px-2 py-2">
                <div className="flex gap-2 items-center">
                  <div className="fix_img">
                    <img src={league_logo || logo_league} width={32} height={32} />
                  </div>
                  <div className={`flex flex-col gap-[1px] ${status === "live" ? "max-w-[212px]" : ""}`}>
                    <Tippy content={`${league_name} • ${name}`}>
                      <span className="max-md:text-sm text-base text-[#FAFAF9] line-clamp-1">
                        {league_name} • {name}
                      </span>
                    </Tippy>
                    <span className="max-md:text-[11px] max-md:leading-[13px] text-base leading-5 text-[#888888] line-clamp-1">
                      {categories_name || category_name}
                    </span>
                  </div>
                </div>
                {status === "live" && (
                  <div className="flex gap-1 bg-[#d1242a] items-center pl-1.5 rounded-full h-full">
                    <div className="text-[#FAFAF9] font-bold text-xs max-md:text-[8px]">LIVE</div>
                    <img src="/icons/iconPlayLive.svg" />
                  </div>
                )}
              </div>
              <div className="flex justify-between items-center px-3 max-md:px-2 gap-2 max-w-full">
                <div className="flex flex-col gap-1 max-md:gap-2 max-w-[90%]">
                  <div className="flex gap-2 items-center py-1">
                    <img
                      src={home_thumbnail}
                      width={isMobile ? 20 : 24}
                      height={isMobile ? 20 : 24}
                      className="fix_img"
                    />
                    <Tippy content={home_name}>
                      <span className="line-clamp-1 text-base max-md:text-sm font-bold text-[#FAFAF9]">
                        {home_name}
                      </span>
                    </Tippy>
                  </div>
                  <div className="flex gap-2 items-center py-1">
                    <img
                      src={away_thumbnail}
                      width={isMobile ? 20 : 24}
                      height={isMobile ? 20 : 24}
                      className="fix_img"
                    />
                    <Tippy content={away_name}>
                      <span className="line-clamp-1 text-base max-md:text-sm font-bold text-[#FAFAF9]">
                        {away_name}
                      </span>
                    </Tippy>
                  </div>
                </div>
                {home_score && away_score ? (
                  <div className="flex flex-col gap-1">
                    <span className="text-base max-md:text-sm font-bold text-[#FAFAF9] py-1">{home_score}</span>
                    <span className="text-base max-md:text-sm font-bold text-[#FAFAF9] py-1">{away_score}</span>
                  </div>
                ) : (
                  <div className="flex flex-col gap-1 items-end">
                    <span className="text-base max-md:text-sm font-bold text-[#FAFAF9] py-1 whitespace-nowrap">
                      {compareDate(start_time)}
                    </span>
                    <span className="text-base max-md:text-sm font-bold text-[#FAFAF9] py-1">
                      {formatTime(start_time)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-3 max-md:gap-2 w-full">
              <div className="flex justify-between items-center rounded-lg bg-[#1a1a1a] px-3 max-sm:px-2 py-2">
                <div className="flex gap-2 items-center">
                  <div className="fix_img">
                    <img src={league_logo || logo_league} width={32} height={32} />
                  </div>
                  <div className={`flex flex-col gap-[1px] ${status === "live" ? "max-w-[212px]" : ""}`}>
                    <Tippy content={`${league_name} • ${name}`}>
                      <span className="max-md:text-sm text-base text-[#FAFAF9] line-clamp-1">
                        {league_name} • {name}
                      </span>
                    </Tippy>
                    <span className="max-md:text-[11px] max-md:leading-[13px] text-base leading-5 text-[#888888] line-clamp-1">
                      {categories_name || category_name}
                    </span>
                  </div>
                </div>
                {status === "live" && (
                  <div className="flex gap-1 bg-[#d1242a] items-center pl-1.5 rounded-full h-full">
                    <div className="text-[#FAFAF9] font-bold text-xs max-md:text-[8px]">LIVE</div>
                    <img src="/icons/iconPlayLive.svg" />
                  </div>
                )}
              </div>
              <div className="flex justify-between items-center px-3 max-md:px-2 gap-2 max-w-full">
                <div className="flex flex-col gap-1 max-md:gap-2 max-w-[90%]">
                  <div className="flex gap-2 items-center py-1">
                    <span className="text-base max-md:text-sm font-medium text-[#FAFAF9]">Số đội thi đấu</span>
                  </div>
                  <div className="flex gap-2 items-center py-1">
                    <img src="/icons/iconPeopleAudience.svg" width={isMobile ? 20 : undefined} />
                    <span className="font-extrabold max-md:text-sm">{number_of_teams}</span>
                  </div>
                </div>
                {status === "live" ? (
                  <div className="flex flex-col gap-1 max-md:gap-2">
                    <div className="flex gap-2 items-center py-1">
                      <span className="text-base max-md:text-sm font-medium text-[#FAFAF9]">Số trận</span>
                    </div>
                    <div className="flex gap-2 items-center py-1 justify-end">
                      <img src="/icons/iconGame.svg" width={isMobile ? 20 : undefined} />
                      <span className="font-extrabold max-md:text-sm">{number_of_matches}</span>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-1 items-end">
                    <span className="text-base max-md:text-sm font-bold text-[#FAFAF9] py-1 whitespace-nowrap">
                      {compareDate(start_time)}
                    </span>
                    <span className="text-base max-md:text-sm font-bold text-[#FAFAF9] py-1">
                      {formatTime(start_time)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

function formatDate(time) {
  let date = new Date(time)
  let day = date.getDate().toString().padStart(2, "0")
  let month = (date.getMonth() + 1).toString().padStart(2, "0")
  return `${day}/${month}`
}

function formatTime(time) {
  let date = new Date(time)
  let hours = date.getHours().toString().padStart(2, "0")
  let minutes = date.getMinutes().toString().padStart(2, "0")
  return `${hours}:${minutes}`
}

function compareDate(time) {
  if (!time) return null

  // Get today's date in local time
  let today = new Date()
  let localToday = new Date(today.getFullYear(), today.getMonth(), today.getDate())

  // Convert the provided UTC time to local time
  let itemDate = new Date(time)
  let localItemDate = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate())

  // Compare the two dates
  return localToday.getTime() === localItemDate.getTime() ? "Hôm nay" : formatDate(localItemDate)
}
